<div class="sw-cms-el-moorl-accordion">
    <sw-cms-el-config-moorl-accordion :element="element"/>
</div>